import React, { useState } from "react";
import axios from "axios";
import { API } from "../../lib/blogApi";

const STATUS = {
  bekreftet: "Takk! Påmeldingen er bekreftet — du får første ukesbrev på fredag.",
  avmeldt: "Du er meldt av nyhetsbrevet. Du får ingen flere e-poster.",
  ugyldig: "Lenken er ugyldig eller utløpt. Meld deg gjerne på igjen.",
};

export const NewsletterStatus = () => {
  const s = new URLSearchParams(window.location.search).get("nyhetsbrev");
  if (!STATUS[s]) return null;
  return <p role="status" data-testid="newsletter-status" className="mt-8 border-2 border-ink bg-[#EAE5DC] px-5 py-4 text-[16px]">{STATUS[s]}</p>;
};

export const NewsletterSignup = ({ defaultLang = "no", compact = false }) => {
  const [email, setEmail] = useState("");
  const [lang, setLang] = useState(defaultLang === "en" ? "en" : "no");
  const [hp, setHp] = useState("");
  const [state, setState] = useState("idle");
  const [msg, setMsg] = useState("");
  const no = lang === "no";

  const submit = async (e) => {
    e.preventDefault();
    setState("busy"); setMsg("");
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, lang, website: hp });
      setState("done");
    } catch (err) {
      setState("idle");
      setMsg(err.response?.status === 422 ? (no ? "Sjekk e-postadressen." : "Check the email address.") : err.response?.data?.detail || (no ? "Noe gikk galt — prøv igjen." : "Something went wrong — try again."));
    }
  };

  return (
    <section data-testid="newsletter-signup" aria-labelledby="nl-h" className={`border-2 border-ink bg-[#EAE5DC] ${compact ? "p-5" : "p-6 md:p-8"}`}>
      <h2 id="nl-h" className="font-serif text-2xl leading-tight">{no ? "Få nye innlegg på e-post" : "Get new posts by email"}</h2>
      <p className="mt-2 text-[16px] leading-relaxed max-w-[60ch]">
        {no ? "Én e-post hver fredag med ukens nye innlegg. Ingen reklame, og du kan melde deg av med ett klikk." : "One email every Friday with the week's new posts. No ads, and you can unsubscribe with one click."}
      </p>
      {state === "done" ? (
        <p role="status" data-testid="newsletter-done" className="mt-4 font-medium">
          {no ? "Nesten ferdig! Sjekk innboksen din og trykk på lenken for å bekrefte." : "Almost done! Check your inbox and click the link to confirm."}
        </p>
      ) : (
        <form onSubmit={submit} className="mt-4 flex flex-wrap items-end gap-3" noValidate>
          <label className="flex flex-col gap-1 font-mono text-[12px] tracking-[0.12em] uppercase grow min-w-[220px]">
            {no ? "E-post" : "Email"}
            <input data-testid="newsletter-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-paper border border-ink px-3 py-2.5 font-sans normal-case tracking-normal text-[16px]" />
          </label>
          <label className="flex flex-col gap-1 font-mono text-[12px] tracking-[0.12em] uppercase">
            {no ? "Språk" : "Language"}
            <select data-testid="newsletter-lang" value={lang} onChange={(e) => setLang(e.target.value)}
              className="bg-paper border border-ink px-3 py-2.5 font-sans normal-case tracking-normal text-[16px]">
              <option value="no">Norsk</option>
              <option value="en">English</option>
            </select>
          </label>
          <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" value={hp} onChange={(e) => setHp(e.target.value)}
            className="absolute -left-[9999px] w-px h-px" name="website" />
          <button data-testid="newsletter-submit" type="submit" disabled={state === "busy" || !email}
            className="px-5 py-2.5 bg-ink text-paper rounded-full font-mono text-[13px] tracking-[0.12em] uppercase hover:bg-ember transition-colors disabled:opacity-60">
            {state === "busy" ? "…" : no ? "Meld meg på" : "Subscribe"}
          </button>
          {msg && <p role="alert" data-testid="newsletter-error" className="basis-full text-[15px] text-ember">{msg}</p>}
          <p className="basis-full text-[13px] text-mist">
            {no ? "Vi lagrer bare e-postadressen og språket ditt, og bruker dem kun til nyhetsbrevet." : "We only store your email and language, and only use them for the newsletter."}{" "}
            <a href="/personvern" className="underline underline-offset-2">{no ? "Personvern" : "Privacy"}</a>
          </p>
        </form>
      )}
    </section>
  );
};
